export const BLOCK_COUNTRY_LIST = [
    'AL',
    'AR',
    'BD',
    'CN',
    'DZ',
    'EG',
    'GH',
    'HK',
    'ID',
    'IN',
    'JM',
    'JP',
    'KE',
    'KH',
    'KR',
    'LK',
    'MA',
    'MK',
    'MU',
    'MX',
    'MY',
    'NG',
    'NP',
    'PH',
    'PK',
    'SA',
    'SG',
    'TH',
    'TN',
    'TT',
    'TW',
    'VE',
    'VN',
    'ZA',
    'ZW',
    'ET',
    'KZ',
    'KG',
    'LV',
    'MD',
    'UA',
];

export const SELLER_COUNTRIES = [
    'IN', // India
    'PK', // Pakistan
    'BD', // Bangladesh
    'PH', // Philippines
    'TH', // Thailand
    'ID', // Indonesia
    'SD', // Sudan
    'NG', // Nigeria
    'LK', // Sri Lanka
    'KE', // Kenya
    'MA', // Morocco
];
